import { motion } from 'framer-motion';

const companies = [
    { 
        name: 'Koch Industries', 
        logo: '/Koch Industries Logo.png',
        className: "h-10 md:h-10" 
    },
    { 
        name: 'Simpplr', 
        logo: 'https://customer-assets.emergentagent.com/job_66b41340-a1ce-4582-8b5b-792b2e2a5ffb/artifacts/747xpccd_simpplr-logo1-white.webp',
        className: "invert h-16 md:h-16" 
    },
    { 
        name: 'Adbloom', 
        logo: 'https://customer-assets.emergentagent.com/job_66b41340-a1ce-4582-8b5b-792b2e2a5ffb/artifacts/e207sjcl_Adbloom_-_revise_log.png.webp',
        className: "invert h-8 md:h-10" 
    },
    { 
        name: 'Ceed Civil', 
        logo: 'https://ceedcivil.com/wp-content/uploads/2023/02/Ceed_Civil_Engineering-1-1.png',
        className: "h-14 md:h-20"
    },
    { 
        name: 'Maple Tree BBQ', 
        logo: 'https://static.wixstatic.com/media/2a8cc6_be65222198694e72bba0f085adfc3c60.png',
        className: "h-14 md:h-20 invert"
    },
    { 
        name: 'The Links Guy', 
        logo: 'https://thelinksguy.com/wp-content/uploads/2023/09/ico-linksguy-footer-logo.webp',
        className: "h-12 md:h-16 invert"
    },
    { 
        name: 'Latitude Wellness', 
        logo: 'https://latitudewellness.com/wp-content/uploads/2023/10/LW-BIG.png',
        className: "h-10 md:h-14"
    },
    { 
        name: 'TapDash', 
        logo: 'https://customer-assets.emergentagent.com/job_66b41340-a1ce-4582-8b5b-792b2e2a5ffb/artifacts/xsfbw4hc_Group1.svg',
        className: "invert h-8 md:h-10" 
    },
];

const duplicatedCompanies = [...companies, ...companies, ...companies];

export const CompanyCarousel = () => {
    return (
        <section className="w-full py-10 border-y border-slate-100 bg-[#FAFAFA]" data-testid="company-carousel">
            <div className="max-w-6xl mx-auto px-6 md:px-12 mb-10">
                <p className="text-slate-400 text-xs font-bold tracking-widest text-center uppercase">
                    Trusted by businesses of all sizes
                </p>
            </div>
            
            <div className="relative overflow-hidden w-full flex">
                {/* Gradient Fades on the edges */}
                <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#FAFAFA] to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#FAFAFA] to-transparent z-10 pointer-events-none" />
                          {/* animate={{
                        x: "-50%", // Moves exactly half the width (seamless loop)
                    }}           */}
                <motion.div
                    className="flex items-center gap-16 pr-16" 
                    animate={{
                        x: "-50%", // Moves exactly half the width (seamless loop)
                    }}           
                    transition={{
                        repeat: Infinity,
                        repeatType: "loop",
                        duration: 40, 
                        ease: "linear",
                    }}
                    style={{
                        width: "max-content", // Ensures the row doesn't wrap
                    }}
                >
                    {duplicatedCompanies.map((company, index) => (
                        <div
                            key={`${company.name}-${index}`}
                            // FIX: min-w-[150px] guarantees a "slot" size.
                            // w-auto allows it to grow if the logo is wider.
                            className="flex-shrink-0 flex items-center justify-center min-w-[150px] w-auto h-24"
                        >
                            <img 
                                src={company.logo} 
                                alt={company.name}
                                // h-10 fixes the height uniformity.
                                // w-auto lets the width adjust to the aspect ratio.
                                className={`w-auto object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300 ${company.className || 'h-10'}`}
                                title={company.name}
                            />
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};